export interface MovieItem {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  year: number;
  rating: number;
  imageUrl: string;
  landscapeUrl: string;
  description: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
  updateInfo: string;
  director: string;
  actors: string[];
  region: string;
  duration: string;
  releaseDate: string;
  fullDescription: string;
  episodes?: number;
  totalEpisodes?: number;
}

export const categories = [
  { name: '电影', slug: 'movie', icon: 'ri-film-line' },
  { name: '电视剧', slug: 'tv', icon: 'ri-tv-line' },
  { name: '综艺', slug: 'variety', icon: 'ri-live-line' },
  { name: '动漫', slug: 'anime', icon: 'ri-ghost-smile-line' },
];

export const movies: MovieItem[] = [
  {
    id: 'm1',
    title: '流浪地球3',
    category: '电影',
    categorySlug: 'movie',
    year: 2026,
    rating: 9.2,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20epic%20astronaut%20in%20space%20dramatic%20cinematic%20lighting%20blue%20orange%20accents%20movie%20poster%20style&width=400&height=600&seq=movie-m1-poster&orientation=portrait',
    landscapeUrl: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20still%20epic%20astronaut%20in%20space%20dramatic%20cinematic%20lighting%20blue%20orange%20accents&width=640&height=360&seq=movie-m1-land&orientation=landscape',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，开启长达2500年的星际流浪之旅。',
    tags: ['科幻', '冒险', '灾难'],
    isHot: true,
    isNew: true,
    updateInfo: '2026-08-01 更新',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健'],
    region: '中国大陆',
    duration: '173分钟',
    releaseDate: '2026-02-10',
    fullDescription: '太阳急速老化膨胀，将在100年内吞没整个地球。为应对这一末日危机，人类联合政府决定启动"流浪地球"计划，在地球表面建造上万座行星发动机，推动地球离开太阳系。在漫长的2500年流浪之旅中，人类面临着前所未有的挑战与考验。第三部延续前作的宏大叙事，讲述人类在星际旅行中遇到的新危机与希望。',
  },
  {
    id: 'm2',
    title: '哪吒之魔童闹海',
    category: '动漫',
    categorySlug: 'anime',
    year: 2025,
    rating: 9.5,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20poster%20Nezha%20fire%20wheels%20red%20ribbon%20dynamic%20action%20mythological%20fiery%20background&width=400&height=600&seq=movie-m2-poster&orientation=portrait',
    landscapeUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20still%20Nezha%20fire%20wheels%20red%20ribbon%20dynamic%20action%20mythological%20fiery%20background&width=640&height=360&seq=movie-m2-land&orientation=landscape',
    description: '哪吒与敖丙经历天劫后灵魂尚存，太乙真人用七色宝莲为他们重塑肉身的故事。',
    tags: ['动画', '神话', '动作'],
    isHot: true,
    isNew: false,
    updateInfo: '2026-07-28 更新',
    director: '饺子',
    actors: ['哪吒', '敖丙', '太乙真人'],
    region: '中国大陆',
    duration: '144分钟',
    releaseDate: '2025-07-20',
    fullDescription: '天劫之后，哪吒和敖丙的灵魂虽得以保存，但肉身面临消散的危机。太乙真人决定用七色宝莲为二人重塑肉身，然而这一过程困难重重。与此同时，四海龙王得知敖丙未死，纷纷前来复仇。哪吒和敖丙必须联手对抗强大的敌人，守护陈塘关的和平。本片延续前作"我命由我不由天"的精神内核，将亲情、友情与成长融入华丽的神话世界之中。',
    episodes: 1,
    totalEpisodes: 1,
  },
  {
    id: 'm3',
    title: '庆余年第二季',
    category: '电视剧',
    categorySlug: 'tv',
    year: 2024,
    rating: 9.3,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%20ancient%20palace%20warrior%20traditional%20costume%20dramatic%20lighting%20epic%20cinematic&width=400&height=600&seq=movie-m3-poster&orientation=portrait',
    landscapeUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20still%20ancient%20palace%20warrior%20traditional%20costume%20dramatic%20lighting&width=640&height=360&seq=movie-m3-land&orientation=landscape',
    description: '范闲从北齐归来后，面对更加复杂的朝堂局势与权力博弈，展开新一轮权谋斗争。',
    tags: ['古装', '权谋', '剧情'],
    isHot: true,
    isNew: true,
    updateInfo: '更新至36集',
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明'],
    region: '中国大陆',
    duration: '45分钟/集',
    releaseDate: '2024-05-16',
    fullDescription: '范闲出使北齐归来，发现京都局势已是风云变幻。二皇子与太子的斗争日趋白热化，庆帝的布局愈发深不可测。范闲在监察院、内库和各方势力之间周旋，一边调查母亲的死亡真相，一边守护自己珍视的人。随着谜团逐渐揭开，范闲发现一切似乎都指向一个更大的秘密。本季剧情更加精彩，权谋层层递进，让人欲罢不能。',
    episodes: 36,
    totalEpisodes: 46,
  },
  {
    id: 'm4',
    title: '奔跑吧第八季',
    category: '综艺',
    categorySlug: 'variety',
    year: 2026,
    rating: 8.8,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20celebrities%20running%20laughing%20colorful%20dynamic%20outdoor%20energetic&width=400&height=600&seq=movie-m4-poster&orientation=portrait',
    landscapeUrl: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20still%20celebrities%20running%20laughing%20colorful%20dynamic%20outdoor%20energetic&width=640&height=360&seq=movie-m4-land&orientation=landscape',
    description: '全新一季奔跑吧兄弟团再度集结，开启更加刺激有趣的挑战之旅。',
    tags: ['真人秀', '竞技', '搞笑'],
    isHot: false,
    isNew: true,
    updateInfo: '更新至第8期',
    director: '姚译添',
    actors: ['李晨', '郑恺', '沙溢', '白鹿', '周深'],
    region: '中国大陆',
    duration: '90分钟/期',
    releaseDate: '2026-06-15',
    fullDescription: '《奔跑吧》第八季全新出发！本季节目将带领观众走进更多中国城市，在奔跑中感受各地的文化魅力和风土人情。常驻嘉宾阵容强大，飞行嘉宾惊喜不断。节目延续了欢乐、正能量的风格，通过精心设计的游戏环节，展现团队协作精神，为观众带来欢笑与感动。',
    episodes: 8,
    totalEpisodes: 12,
  },
  {
    id: 'm5',
    title: '封神第二部',
    category: '电影',
    categorySlug: 'movie',
    year: 2025,
    rating: 9.0,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20movie%20poster%20ancient%20warriors%20mythical%20creatures%20epic%20battle%20golden%20crimson&width=400&height=600&seq=movie-m5-poster&orientation=portrait',
    landscapeUrl: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20movie%20still%20ancient%20warriors%20mythical%20creatures%20epic%20battle&width=640&height=360&seq=movie-m5-land&orientation=landscape',
    description: '殷寿暴虐无道引发天谴，姬发觉醒带领八百诸侯举兵伐纣，封神大战开启。',
    tags: ['神话', '战争', '奇幻'],
    isHot: true,
    isNew: false,
    updateInfo: '2026-07-15 更新',
    director: '乌尔善',
    actors: ['费翔', '黄渤', '于适'],
    region: '中国大陆',
    duration: '158分钟',
    releaseDate: '2025-07-01',
    fullDescription: '殷寿弑父杀兄，登上王位，暴虐无道引发天谴。昆仑仙人姜子牙携封神榜下山，寻找天下共主以救苍生。姬发被殷寿囚禁于朝歌，历经磨难后终于觉醒，逃回西岐。在姜子牙的辅佐下，姬发举起反商大旗，八百诸侯纷纷响应，一场改变天地格局的封神大战就此拉开序幕。本片场面宏大，特效精良，继承第一部的史诗气质。',
  },
  {
    id: 'm6',
    title: '时光代理人',
    category: '动漫',
    categorySlug: 'anime',
    year: 2024,
    rating: 9.1,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20poster%20two%20young%20men%20mysterious%20time-travel%20clock%20motif%20urban%20fantasy%20cool%20stylish&width=400&height=600&seq=movie-m6-poster&orientation=portrait',
    landscapeUrl: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20still%20two%20young%20men%20mysterious%20time-travel%20clock%20motif%20urban%20fantasy&width=640&height=360&seq=movie-m6-land&orientation=landscape',
    description: '两个年轻人经营着一家时光照相馆，通过照片进入过去改变事件走向。',
    tags: ['悬疑', '奇幻', '剧情'],
    isHot: false,
    isNew: false,
    updateInfo: '2026-06-20 更新',
    director: '李豪凌',
    actors: ['程小时', '陆光', '乔苓'],
    region: '中国大陆',
    duration: '24分钟/集',
    releaseDate: '2024-10-01',
    fullDescription: '在繁华都市的一角，有一家名为"时光照相馆"的小店。店主程小时和陆光拥有特殊能力——通过照片进入过去，改变已经发生的事件。然而，每一次改变都可能引发蝴蝶效应。乔苓作为两人的搭档，负责协调现实中的各种状况。三人一起接受委托，在时光的缝隙中穿梭，揭开隐藏在照片背后的真相。',
    episodes: 12,
    totalEpisodes: 12,
  },
  {
    id: 'm7',
    title: '繁花',
    category: '电视剧',
    categorySlug: 'tv',
    year: 2024,
    rating: 9.4,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%201990s%20Shanghai%20nostalgic%20neon%20lights%20elegant%20suit%20golden%20warm%20tones%20cinematic&width=400&height=600&seq=movie-m7-poster&orientation=portrait',
    landscapeUrl: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20still%201990s%20Shanghai%20nostalgic%20neon%20lights%20elegant%20suit%20golden%20warm&width=640&height=360&seq=movie-m7-land&orientation=landscape',
    description: '九十年代的上海，阿宝凭借改革开放的春风和自己的打拼，成为商界后起之秀。',
    tags: ['都市', '商战', '年代'],
    isHot: true,
    isNew: false,
    updateInfo: '全30集',
    director: '王家卫',
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    region: '中国大陆',
    duration: '45分钟/集',
    releaseDate: '2024-01-09',
    fullDescription: '九十年代的上海，处处是机遇与挑战。阿宝从一个普通青年，凭借敏锐的商业嗅觉和敢闯敢拼的精神，在股市和外贸中闯出一片天地。黄河路上，他结识了至交好友，也遭遇了商场对手。在金钱与情感的漩涡中，阿宝经历了人生的大起大落。本片以细腻的笔触描绘了那个充满激情与梦想的时代，展现了上海这座城市的独特魅力。',
    episodes: 30,
    totalEpisodes: 30,
  },
  {
    id: 'm8',
    title: '披荆斩棘4',
    category: '综艺',
    categorySlug: 'variety',
    year: 2026,
    rating: 8.5,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20music%20competition%20show%20poster%20male%20celebrities%20stylish%20stage%20concert%20lighting%20dramatic&width=400&height=600&seq=movie-m8-poster&orientation=portrait',
    landscapeUrl: 'https://readdy.ai/api/search-image?query=Chinese%20music%20competition%20show%20still%20male%20celebrities%20stylish%20stage%20concert%20lighting&width=640&height=360&seq=movie-m8-land&orientation=landscape',
    description: '多位实力男艺人同台竞技，用歌声和舞台展现自己的实力与魅力。',
    tags: ['音乐', '竞技', '真人秀'],
    isHot: false,
    isNew: true,
    updateInfo: '更新至第5期',
    director: '吴梦知',
    actors: ['多位实力歌手及演员'],
    region: '中国大陆',
    duration: '120分钟/期',
    releaseDate: '2026-07-10',
    fullDescription: '《披荆斩棘》第四季强势回归！本季节目集结了更多实力派男艺人，他们将在这个舞台上突破自我，挑战不同风格的音乐和舞蹈。从摇滚到抒情，从中国风到流行，每一位哥哥都将用最真诚的表演打动观众。节目中不仅有精彩的舞台，更有哥哥们之间真挚的友情和成长故事。',
    episodes: 5,
    totalEpisodes: 12,
  },
  {
    id: 'm9',
    title: '长安三万里',
    category: '动漫',
    categorySlug: 'anime',
    year: 2024,
    rating: 9.3,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20historical%20film%20poster%20Tang%20Dynasty%20Chang%20an%20poets%20traditional%20robes%20moonlit%20ink%20wash%20painting&width=400&height=600&seq=movie-m9-poster&orientation=portrait',
    landscapeUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20historical%20film%20still%20Tang%20Dynasty%20Chang%20an%20poets%20traditional%20robes%20moonlit%20ink%20wash&width=640&height=360&seq=movie-m9-land&orientation=landscape',
    description: '讲述高适与李白跨越数十年的深厚友谊，再现大唐盛世风华与诗人传奇。',
    tags: ['历史', '诗词', '传记'],
    isHot: true,
    isNew: false,
    updateInfo: '2026-05-10 更新',
    director: '谢君伟',
    actors: ['李白', '高适', '杜甫'],
    region: '中国大陆',
    duration: '168分钟',
    releaseDate: '2024-07-08',
    fullDescription: '安史之乱后，大唐由盛转衰。困守孤城的高适回忆起与李白跨越数十年的交往。从年少相识，到一同游历天下，再到各自追求理想。李白恃才傲物，意气风发；高适沉稳内敛，脚踏实地。两人性格迥异却惺惺相惜，在动荡的时代中，见证了彼此的辉煌与落寞，也亲历了大唐的兴衰。本片以绝美的水墨动画风格，再现了盛唐时期的长安风华。',
  },
  {
    id: 'm10',
    title: '满江红',
    category: '电影',
    categorySlug: 'movie',
    year: 2024,
    rating: 8.9,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20suspense%20movie%20poster%20ancient%20courtyard%20night%20lanterns%20mysterious%20red%20black%20thriller&width=400&height=600&seq=movie-m10-poster&orientation=portrait',
    landscapeUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20suspense%20movie%20still%20ancient%20courtyard%20night%20lanterns%20mysterious%20red%20black&width=640&height=360&seq=movie-m10-land&orientation=landscape',
    description: '南宋绍兴年间，一个小兵与亲兵营副统领被迫卷入一场惊天阴谋之中。',
    tags: ['悬疑', '历史', '喜剧'],
    isHot: false,
    isNew: false,
    updateInfo: '2026-04-20 更新',
    director: '张艺谋',
    actors: ['沈腾', '易烊千玺', '张译', '雷佳音'],
    region: '中国大陆',
    duration: '159分钟',
    releaseDate: '2024-01-22',
    fullDescription: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信也不翼而飞。一个小兵张大与亲兵营副统领孙均被卷入这场风波，被迫在有限时间内找出真相。随着调查的深入，各方势力暗流涌动，一场关于忠诚、正义与牺牲的故事徐徐展开。',
  },
  {
    id: 'm11',
    title: '狂飙',
    category: '电视剧',
    categorySlug: 'tv',
    year: 2023,
    rating: 9.5,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20drama%20poster%20police%20officer%20gangster%20facing%20off%20dark%20urban%20noir&width=400&height=600&seq=movie-m11-poster&orientation=portrait',
    landscapeUrl: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20drama%20still%20police%20officer%20gangster%20facing%20off%20dark%20urban%20noir&width=640&height=360&seq=movie-m11-land&orientation=landscape',
    description: '一线刑警安欣与黑恶势力长达二十年的生死较量，展现扫黑除恶的决心。',
    tags: ['刑侦', '扫黑', '剧情'],
    isHot: true,
    isNew: false,
    updateInfo: '全39集',
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐'],
    region: '中国大陆',
    duration: '45分钟/集',
    releaseDate: '2023-01-14',
    fullDescription: '京海市一线刑警安欣，在与黑恶势力的斗争中，不断遭到保护伞的打击，始终无法将犯罪分子绳之以法。多年后，全国政法队伍教育整顿工作开展，临江省派出指导组入驻京海，联合公检法司各部门，一举铲除了盘踞京海多年的强盛集团。安欣与专案组协作，终于将高启强及其背后的保护伞一网打尽，还京海一片青天。',
    episodes: 39,
    totalEpisodes: 39,
  },
  {
    id: 'm12',
    title: '王牌对王牌8',
    category: '综艺',
    categorySlug: 'variety',
    year: 2024,
    rating: 8.6,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20game%20show%20poster%20celebrities%20playing%20fun%20games%20stage%20colorful%20comedic&width=400&height=600&seq=movie-m12-poster&orientation=portrait',
    landscapeUrl: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20game%20show%20still%20celebrities%20playing%20fun%20games%20stage%20colorful&width=640&height=360&seq=movie-m12-land&orientation=landscape',
    description: '经典IP对决综艺回归，明星嘉宾分成两队展开趣味游戏对决。',
    tags: ['游戏', '搞笑', '经典'],
    isHot: false,
    isNew: false,
    updateInfo: '2026-03-15 更新',
    director: '吴彤',
    actors: ['沈腾', '贾玲', '华晨宇', '关晓彤'],
    region: '中国大陆',
    duration: '90分钟/期',
    releaseDate: '2024-03-01',
    fullDescription: '《王牌对王牌》第八季欢乐继续！经典游戏环节全面升级，更多爆笑挑战等你来看。王牌家族与飞行嘉宾组成对战阵容，在才艺比拼、智力较量和团队协作中展开角逐。每一期都有惊喜嘉宾和意想不到的精彩表现，为观众带来满满的欢乐。',
    episodes: 12,
    totalEpisodes: 12,
  },
];

export const getMoviesByCategory = (slug: string): MovieItem[] => {
  return movies.filter((m) => m.categorySlug === slug);
};

export const getMovieById = (id: string): MovieItem | undefined => {
  return movies.find((m) => m.id === id);
};

export const getHotMovies = (): MovieItem[] => {
  return movies.filter((m) => m.isHot);
};

export const getNewMovies = (): MovieItem[] => {
  return movies.filter((m) => m.isNew);
};

export const getRelatedMovies = (id: string, count: number = 4): MovieItem[] => {
  const current = getMovieById(id);
  if (!current) return [];
  return movies
    .filter((m) => m.id !== id && m.categorySlug === current.categorySlug)
    .slice(0, count);
};